// Candy-Fly Animation: animiert nur die drei echten Suessigkeiten-Marken,
    // die in der Original-Illustration zwischen der Hand des werfenden
    // Mascots und dem Mund des fangenden Mascots eingezeichnet sind
    // (id="candy-1".."candy-3"). Die zwei kurzen Bogenstriche direkt an der
    // Hand sind der Wurf-Luftzug und bleiben bewusst unangetastet/statisch.
    (function(){
      var stage = document.querySelector('.mascot-stage');
      if(!stage) return;

      var MOUTH = {x:165.8, y:105.6};
      // Jeder Bonbon bekommt einen leicht anderen Zielpunkt rund um den Mund,
      // statt alle exakt auf denselben Pixel zu schicken -- das ist der
      // Hauptgrund, warum sie sich vorher ueberlappt haben.
      var CANDIES = [
        {id:'candy-1', from:{x:126.8, y:51.6}, phase:0.0,  target:{x:MOUTH.x - 4, y:MOUTH.y - 3}},
        {id:'candy-2', from:{x:139.6, y:63.3}, phase:0.33, target:{x:MOUTH.x + 3, y:MOUTH.y + 1}},
        {id:'candy-3', from:{x:150.3, y:79.9}, phase:0.66, target:{x:MOUTH.x - 1, y:MOUTH.y + 4}}
      ].map(function(c){
        c.el = document.getElementById(c.id);
        c.dx = c.target.x - c.from.x;
        c.dy = c.target.y - c.from.y;
        return c;
      }).filter(function(c){ return !!c.el; });

      var CYCLE = 260;
      // Frueher ausblenden, damit nie zwei Bonbons gleichzeitig kurz vor dem
      // Ziel (und damit optisch uebereinander) sichtbar sind.
      var FADE_IN_END = 0.1;
      var FADE_OUT_START = 0.62;
      var FADE_OUT_END = 0.82;
      var ticking = false;

      function update(){
        var scrollY = window.scrollY || window.pageYOffset || 0;

        CANDIES.forEach(function(c){
          var t = (((scrollY / CYCLE) + c.phase) % 1 + 1) % 1;
          var px = c.dx * t;
          var py = c.dy * t;
          var scale = 1 - 0.35 * t;
          c.el.style.transform = 'translate(' + px + 'px,' + py + 'px) scale(' + scale + ')';

          var opacity = 1;
          if(t < FADE_IN_END){
            opacity = t / FADE_IN_END;
          } else if(t > FADE_OUT_START){
            opacity = 1 - (t - FADE_OUT_START) / (FADE_OUT_END - FADE_OUT_START);
          }
          c.el.style.opacity = Math.max(0, Math.min(1, opacity));
        });
        ticking = false;
      }

      function onScroll(){
        if(!ticking){
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll, {passive:true});
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
    })();

    // Skateboard-Mascot: immer nur EIN Suessigkeitsstueck, das nach jedem
    // Durchlauf wieder von vorne beginnt. Flugbahn ist eine einzige breite
    // Sinuskurve ueber den gesamten Durchlauf, Tempo folgt der Scrollgeschwindigkeit.
    (function(){
      var stage = document.querySelector('.skate-stage');
      if(!stage) return;
      var img = stage.querySelector('img');
      var candy = document.getElementById('ground-candy-1');
      if(!img || !candy) return;

      var CYCLE = 900;
      var GROUND_MARGIN = 34;
      var START_X = -50;
      var END_X = 150;
      var MAX_JUMP = 42;
      var CANDY_SIZE = 36;
      var ticking = false;

      function update(){
        var w = stage.offsetWidth;
        var groundY = img.offsetTop + img.offsetHeight + GROUND_MARGIN;
        var scrollY = window.scrollY || window.pageYOffset || 0;

        var t = ((scrollY / CYCLE) % 1 + 1) % 1;
        var xPct = START_X + t * (END_X - START_X);
        var px = (xPct / 100) * w - CANDY_SIZE / 2;
        var py = groundY - CANDY_SIZE / 2;
        candy.style.transform = 'translate(' + px + 'px,' + py + 'px)';

        var opacity = 1;
        if(t < 0.02){ opacity = t / 0.02; }
        else if(t > 0.98){ opacity = (1 - t) / 0.02; }
        candy.style.opacity = Math.max(0, Math.min(1, opacity));

        var arc = Math.sin(t * Math.PI);
        var jumpPx = MAX_JUMP * arc;
        var squash = 1 - 0.06 * arc;
        img.style.transform = 'translateY(' + (-jumpPx) + 'px) scaleY(' + squash + ')';
        img.style.transformOrigin = 'bottom center';

        ticking = false;
      }

      function onScroll(){
        if(!ticking){
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll, {passive:true});
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
    })();

    // Magnetische Mikrointeraktion fuer Buttons -- nur bei echter Maus mit
    // Hover-Faehigkeit (Desktop).
    (function(){
      var isFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if(!isFinePointer) return;

      var STRENGTH = 0.32;
      var MAX_OFFSET = 9;

      document.querySelectorAll('.btn').forEach(function(btn){
        btn.addEventListener('mousemove', function(e){
          var rect = btn.getBoundingClientRect();
          var relX = e.clientX - (rect.left + rect.width / 2);
          var relY = e.clientY - (rect.top + rect.height / 2);
          var dx = Math.max(-MAX_OFFSET, Math.min(MAX_OFFSET, relX * STRENGTH));
          var dy = Math.max(-MAX_OFFSET, Math.min(MAX_OFFSET, relY * STRENGTH));
          btn.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
        });
        btn.addEventListener('mouseleave', function(){
          btn.style.transform = '';
        });
      });
    })();

    // Scroll-Progress-Indikator "Candy-Faden"
    (function(){
      var fill = document.querySelector('.candy-progress-fill');
      var dot = document.querySelector('.candy-progress-dot');
      if(!fill || !dot) return;

      var ticking = false;
      function update(){
        var scrollTop = window.scrollY || window.pageYOffset || 0;
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        var pct = docHeight > 0 ? Math.min(1, Math.max(0, scrollTop / docHeight)) : 0;
        var pctStr = (pct * 100) + '%';
        fill.style.width = pctStr;
        dot.style.left = pctStr;
        ticking = false;
      }
      function onScroll(){
        if(!ticking){
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }
      window.addEventListener('scroll', onScroll, {passive:true});
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
    })();